var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53597 18.4519L4 20L5.54812 14.464L15.6798 4.37285C15.7933 4.24317 15.9311 4.16212 16.0932 4.09727C16.2391 4.04054 16.4093 4 16.5714 4C16.7335 4 16.8875 4.04054 17.0496 4.09727C17.1955 4.16212 17.3333 4.25938 17.4549 4.37285L19.6271 6.5613C19.7406 6.67477 19.8379 6.80446 19.9027 6.96657C19.9595 7.11246 20 7.27457 20 7.44478C20 7.61499 19.9595 7.769 19.9027 7.91489C19.8379 8.06079 19.7568 8.19858 19.6271 8.32016L9.54408 18.46H9.53597V18.4519Z",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0a5a61ad2f549b52945a93b8b7cdbd47.svg";
export { ForwardRef as ReactComponent };